import i18n from '@/plugins/i18n'

export default {
  namespaced: true,
  state: {
    language: process.env.VUE_APP_I18N_LOCALE,
    list: [
      {
        title: i18n.t('general.languages.english'),
        value: 'en'
      },
      // {
      //   title: i18n.t('general.languages.spanish'),
      //   value: 'es'
      // },
      // {
      //   title: i18n.t('general.languages.french'),
      //   value: 'fr'
      // },
      {
        title: i18n.t('general.languages.netherlands'),
        value: 'nl'
      }
    ]
  },
  getters: {
    current: state => state.language,
    list: state => state.list
  },
  mutations: {
    SET_LANGUAGE (state, lang) {
      localStorage.setItem('language', lang)
      state.language = lang
    }
  },
  actions: {
    setLanguage ({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    init ({ commit }) {
      commit('SET_LANGUAGE', localStorage.getItem('language') || process.env.VUE_APP_I18N_LOCALE)
    }
  }
}
